<template>
    <div :class="['block-team', 'popin-content']">
        <div class="block">
            <div
                class="image-holder"
            >
                <div
                    class="image-gabarit"
                    :style="{
                    backgroundImage: `url(${data.image.url || '/assets/empty-image.svg'})`
                    }"
                >
                    <img
                        :src="data.image.url"
                        :alt="data.image.alt"
                        :title="data.image.title"
                        class="seo-image"
                    />
                </div>
            </div>
            <div class="content">
                <p class="name">{{data.firstname}} {{data.lastname}}</p>
                <p class="role">{{data.role}}</p>
                <div class="columns text" v-if="data.longdescription">
                    <div class="column" v-html="data.longdescription.column1"/>
                    <div class="column" v-html="data.longdescription.column2"/>
                </div>
            </div>
            <div
                class="close"
                @click="$emit('close')"
            >
                <IconPlus/> {{$t('cta.close')}}
            </div>
        </div>
    </div>
</template>

<script>
import IconPlus from '@/components/IconPlus'
export default {
    components: {
        IconPlus
    },
    props: {
        data: {
            type: Object,
            default() {return {}}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.block-team
    background-color: #ffffff
    padding-top: 8%
    padding-bottom: 8%
    width: 100%
    max-height: 100%
    overflow: auto
.image-holder
    width: 312px
    min-width: 312px
    margin-top: 13px
    margin-bottom: 3.75em
    @include media-breakpoint-down($lg)
        width: 100%
        min-width: 0
        max-width: 312px
    @include media-breakpoint-down($sm)
        margin-top: 45px

    .image-gabarit
        padding-bottom: 97.4193548387%
        background-position: 50% 50%
        background-repeat: no-repeat
        background-size: cover
p
    font-size: 28px
    &.name
        font-weight: 500
        color: #ff2b2a
        margin-bottom: .3em
        letter-spacing: -0.03125em
    &.role
        font-weight: 500
        letter-spacing: -0.03125em
    &.description
        margin-top: 2.4em
        line-height: 1.2
.block
    display: flex
    @include media-breakpoint-down($lg)
        flex-direction: column
        align-items: center
.content
    flex: 1
    padding-left: 8%
    padding-right: 8%
.columns
    margin-top: 2.4em
    display: flex
    justify-content: space-between
    @include media-breakpoint-down($hd)
        flex-direction: column
    .column
        flex: .4625
svg
    width: 30px
    height: 30px
    transform: rotate(45deg)
    margin-right: .5em
    /deep/ path
        fill: #ff4a4a
.close
    color: #ff4a4a
    font-size: 20px
    font-weight: 500
    display: flex
    align-items: center
    align-self: baseline
    cursor: pointer
    position: absolute
    right: 0
    margin-right: 9.6%
</style>
